import { regions } from '@r1-frontend/geo/data/regions';

interface ICityByRegion {
    name: string,
    region: string,
}

export const getCityByRegion = ({ name, region }: ICityByRegion) => {
    const foundedRegion = regions[region];

    if (!foundedRegion) {
        return;
    }

    return foundedRegion[Object.keys(foundedRegion).find(cityName => cityName === name) ?? 'default'];
};
